<template>
  <base-page>
    <titlu-pagina Titlu="Dashboard" :AdaugaVisible="false"></titlu-pagina>

    <el-card style="margin: 5px 0px 5px 0px">
      <div slot="header" class="clearfix">
        <strong>Admin</strong> |
        <span class="tag-logged">Service-evio</span>
      </div>
      <div class="menu">

   
        <button v-if="this.$has_right('Management')" type="button" class="btn btn-light" @click="$router.push('categorii_produse')">Categorii Produse</button>
        <button v-if="this.$has_right('Management')" type="button" class="btn btn-light" @click="$router.push('produse')">Produse</button>
        <button v-if="this.$has_right('Management')" type="button" class="btn btn-light" @click="$router.push('masini')">Masini</button>
        <button v-if="this.$has_right('Management')" type="button" class="btn btn-light" @click="$router.push('clienti')">Clienti</button>
        <button v-if="this.$has_right('Management') || this.$has_right('Receptie')" type="button" class="btn btn-light" @click="$router.push('rezervari')">Rezervari</button>
        <button v-if="this.$has_right('Management')" type="button" class="btn btn-light" @click="$router.push('consimtamant')">Consimtamant</button>


      </div>
    </el-card>
  </base-page>
</template>

<script>
import settings from "../../backend/LocalSettings";
import BasePage from "../../pages/Admin/BasePage";
import TitluPagina from "../../widgets/TitluPagina";

export default {
  name: "dashboard",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {};
  },
  methods: {
    async get_info() {
      this.refresh_info();
    },

    async refresh_info() {
      this.select_menu_item("dashboard");
    },
  },
  mounted() {
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.tag-logged {
  font-size: 12px;
  opacity: 0.5;
}

.menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
}

.menu button {
  width: 250px;
  height: 250px;
  margin-top: 20px;
}

@media only screen and (max-width: 600px) {
  /* Pentru telefon: */
  .menu button {
  width: 150px;
  height: 150px;
  margin-top: 20px;
}
}
</style>
